import { Component, OnInit } from '@angular/core';

@Component({
  template: require('./manutencoes.component.html')
})
export class ManutencoesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/manutencoes.component.ts
 **/